export default "__VITE_PUBLIC_ASSET__9537a9e5__"